import { version as packageVersion } from "../../../package.json";

export const spaVersion = packageVersion;
export const spaBuildId = spaVersion;

export type SpaBuildInfo = {
  version: string;
  buildId: string;
};

export const spaBuildInfo: SpaBuildInfo = {
  version: spaVersion,
  buildId: spaBuildId,
};
